import { render, staticRenderFns } from "./Part2.vue?vue&type=template&id=dc412a1e&scoped=true"
import script from "./Part2.vue?vue&type=script&lang=js"
export * from "./Part2.vue?vue&type=script&lang=js"
import style0 from "./Part2.vue?vue&type=style&index=0&id=dc412a1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc412a1e",
  null
  
)

export default component.exports